import React, { useEffect, useState } from "react";
import "chart.js/auto";
import "bootstrap/dist/css/bootstrap.min.css";
import MidSections from "./MidSections";
import axiosinstances from "../../Helper/useAxios";
import { useSelector } from "react-redux";
import {
  applyReversedToSuccess,
  isActualSuccessStatus,
  payoutforPI,
  statusIntialData,
} from "../../utils/Constant";
import "./graph.css";
import { appVersion } from "../../version";
import { toast } from "react-toastify";
const BARGRAPH = "BARGRAPH";
const PIEGRAPH = "PIEGRAPH";

const HomePage = () => {
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);
  const today = new Date().toISOString().split("T")[0];

  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
  };
  const mid = JSON.parse(sessionStorage.getItem("mid"));

  const [transactionStatuswithAmountPin, setTransactionStatuswithAmountPin] =
    useState(statusIntialData);
  const [transactionStatuswithAmountPout, setTransactionStatuswithAmountPout] =
    useState(statusIntialData);
  const [
    transactionStatuswithAmountPinBar,
    setTransactionStatuswithAmountPinBar,
  ] = useState([]);
  const [
    transactionStatuswithAmountPoutBar,
    setTransactionStatuswithAmountPoutBar,
  ] = useState([]);
  const [selectedDatePin, setSelectedDatePin] = useState(today);
  const [selectedDatePout, setSelectedDatePout] = useState(today);
  const storeData = useSelector(
    (state) => state?.configDetailsreducer?.details
  );

  const [warningShown, setWarningShown] = useState(false);
  const currentVersionfromApi =
    (Array.isArray(storeData) &&
      storeData.filter(
        (val) => val.id == "REACT_APP_QRBONPAY_MER_PORTAL_CUREENT_VERSION"
      )) ||
    [];
  useEffect(() => {
    if (
      appVersion &&
      Array.isArray(currentVersionfromApi) &&
      currentVersionfromApi.length > 0
    ) {
      const apiCurrentVersion = currentVersionfromApi[0]?.value;
      if (apiCurrentVersion !== appVersion && !warningShown) {
        toast.warn(
          `Kindly reload your application, a new version ${apiCurrentVersion} is available.`
        );
        setWarningShown(true); // Set the flag to prevent further warnings
      }
    }
  }, [currentVersionfromApi, appVersion, warningShown]);
  useEffect(() => {
    // Fetch data for the last 5 days on component mount
    const fetchLast5DaysData = async () => {
      const today = new Date();
      const last5Days = [];

      for (let i = 0; i < 5; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const formattedDate = date.toISOString().split("T")[0];
        await getStatusPin(formattedDate, BARGRAPH);
        await getStatusPout(formattedDate, BARGRAPH);
      }
    };

    fetchLast5DaysData();
  }, [mid]);

  // const getStatusPin = async (date, graph) => {
  //   const url =
  //     mid !== null &&
  //     mid !== undefined &&
  //     mid !== "" &&
  //     `/api/v1/upi/reporting/mis/payin?date=${date}&mid=${mid}`;

  //   try {
  //     const response = await axiosInstance.get(url, { headers });

  //     let successCounts = 0,
  //       failedCounts = 0,
  //       pendingCounts = 0,
  //       successAmount = 0,
  //       failedAmount = 0,
  //       pendingAmount = 0;

  //     response.data.forEach((status) => {
  //       if (status.id.startsWith("SUCCESS")) {
  //         successCounts += status.count;
  //         successAmount += parseInt(status.amount);
  //       } else if (
  //         status.id === "FAILED" ||
  //         status.id === "REVERSED" ||
  //         status.id === "SYS_ERROR" ||
  //         status.id === "CANCELED" ||
  //         status.id === "UNPROCESSED"
  //       ) {
  //         failedCounts += status.count;
  //         failedAmount += parseInt(status.amount);
  //       } else {
  //         pendingCounts += status.count;
  //         pendingAmount += parseInt(status.amount);
  //       }
  //     });

  //     const result = [
  //       { id: "SUCCESS", amount: successAmount, count: successCounts },
  //       { id: "FAILED", amount: failedAmount, count: failedCounts },
  //       { id: "PENDING", amount: pendingAmount, count: pendingCounts },
  //     ];
  //     if (graph == PIEGRAPH) {
  //       setTransactionStatuswithAmountPin(result);
  //     } else if (graph == BARGRAPH) {
  //       setTransactionStatuswithAmountPinBar((prevState) => {
  //         const existingEntryIndex = prevState.findIndex(
  //           (item) => item.date === date
  //         );

  //         if (existingEntryIndex !== -1) {
  //           const updatedState = [...prevState];
  //           updatedState[existingEntryIndex] = { date, data: result };
  //           return updatedState;
  //         } else {
  //           return [...prevState, { date, data: result }];
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching PAY-IN data:", error);
  //     // Handle error, show toast, etc.
  //   }
  // };

  const getStatusPin = async (date, graph) => {
    let url = `/api/v1/upi/reporting/mis/payin`;

    // Build request body similar to your POST method
    let request = {
      date: date,
      endDate: null,
      mid: mid !== null && mid !== undefined && mid ? mid : "",
      midList: [],
      type: "",
      vpaList: [],
      txnType: ["UPI", "FUND_TRANSFER"], // ✅ same as your POST version
      splitByAccount: false,
      splitByMid: false,
    };

    try {
      const response = await axiosInstance.post(url, request, { headers });

      let successCounts = 0,
        failedCounts = 0,
        pendingCounts = 0,
        successAmount = 0,
        failedAmount = 0,
        pendingAmount = 0;

      // ✅ response structure: array (same as your GET version)
      let values = response.data;

      values.forEach((status) => {
        if (isActualSuccessStatus(status.id)) {
          successCounts += status.count;
          // ⚡ Notice: POST uses processedAmount, not amount
          successAmount += parseInt(status.processedAmount);
        } else if (
          status.id === "FAILED" ||
          status.id === "REVERSED" ||
          status.id === "SYS_ERROR" ||
          status.id === "CANCELED" ||
          status.id === "UNPROCESSED"
        ) {
          failedCounts += status.count;
          failedAmount += parseInt(status.amount);
        } else {
          pendingCounts += status.count;
          pendingAmount += parseInt(status.amount);
        }
      });

      const result = [
        { id: "SUCCESS", amount: successAmount, count: successCounts },
        { id: "FAILED", amount: failedAmount, count: failedCounts },
        { id: "PENDING", amount: pendingAmount, count: pendingCounts },
      ];

      if (graph === PIEGRAPH) {
        setTransactionStatuswithAmountPin(result);
      } else if (graph === BARGRAPH) {
        setTransactionStatuswithAmountPinBar((prevState) => {
          const existingEntryIndex = prevState.findIndex(
            (item) => item.date === date
          );

          if (existingEntryIndex !== -1) {
            const updatedState = [...prevState];
            updatedState[existingEntryIndex] = { date, data: result };
            return updatedState;
          } else {
            return [...prevState, { date, data: result }];
          }
        });
      }
    } catch (error) {
      console.error("Error fetching PAY-IN data:", error);
      // Handle error, show toast, etc.
      toast.error("Something went wrong");
    }
  };

  // const getStatusPout = async (date, graph) => {
  //   const url =
  //     mid !== null &&
  //     mid !== undefined &&
  //     mid !== "" &&
  //     `/api/v1/upi/reporting/mis/payout?date=${date}&mid=${mid}`;

  //   try {
  //     const response = await axiosInstance.get(url, { headers });

  //     let successCounts = 0,
  //       failedCounts = 0,
  //       pendingCounts = 0,
  //       successAmount = 0,
  //       failedAmount = 0,
  //       pendingAmount = 0;
  //     let values = response.data?.first; //response.data?.first
  //     let secondsValue = response.data?.second;
  //     values.forEach((status) => {
  //       if (status.id.startsWith("SUCCESS")) {
  //         successCounts += status.count;
  //         successAmount += parseInt(status.amount);
  //       } else if (
  //         status.id === "FAILED" ||
  //         status.id === "REVERSED" ||
  //         status.id === "SYS_ERROR" ||
  //         status.id === "CANCELED" ||
  //         status.id === "UNPROCESSED"
  //       ) {
  //         failedCounts += status.count;
  //         failedAmount += parseInt(status.amount);
  //       } else {
  //         pendingCounts += status.count;
  //         pendingAmount += parseInt(status.amount);
  //       }
  //     });

  //     const result1 = [
  //       { id: "SUCCESS", amount: successAmount, count: successCounts },
  //       { id: "FAILED", amount: failedAmount, count: failedCounts },
  //       { id: "PENDING", amount: pendingAmount, count: pendingCounts },
  //     ];

  //     const result = await applyReversedToSuccess(result1, secondsValue);
  //     if (graph === PIEGRAPH) {
  //       setTransactionStatuswithAmountPout(result);
  //     } else if (graph == BARGRAPH) {
  //       // setTransactionStatuswithAmountPoutBar(prevState => [...prevState, { date, data: result }]);
  //       setTransactionStatuswithAmountPoutBar((prevState) => {
  //         const existingEntryIndex = prevState.findIndex(
  //           (item) => item.date === date
  //         );

  //         if (existingEntryIndex !== -1) {
  //           const updatedState = [...prevState];
  //           updatedState[existingEntryIndex] = { date, data: result };
  //           return updatedState;
  //         } else {
  //           return [...prevState, { date, data: result }];
  //         }
  //       });
  //     }
  //   } catch (error) {
  //     console.error("Error fetching PAY-OUT data:", error);
  //     // Handle error, show toast, etc.
  //   }
  // };

  const getStatusPout = async (date, graph) => {
    const url = `/api/v1/upi/reporting/mis/payout`;

    let request = {
      date: date,
      endDate: null,
      mid: mid !== null && mid !== undefined && mid ? mid : "",
      midList: [],
      type: "",
      vpaList: [],
      txnType: [],
      splitByAccount: false,
      splitByMid: false,
    };

    try {
      const response = await axiosInstance.post(url, request, { headers });

      let successCounts = 0,
        failedCounts = 0,
        pendingCounts = 0,
        successAmount = 0,
        failedAmount = 0,
        pendingAmount = 0;

      let values = response.data?.first;
      let secondsValue = response.data?.second;

      values.forEach((status) => {
        if (isActualSuccessStatus(status.id)) {
          successCounts += status.count;
          successAmount += parseInt(status.amount);
        } else if (status.id === "REVERSED") {
          // ✅ same handling like your post API
          successCounts -= status.count;
          successAmount -= parseInt(status.amount);
          failedCounts += status.count;
          failedAmount += parseInt(status.amount);
        } else if (
          status.id === "FAILED" ||
          status.id === "SYS_ERROR" ||
          status.id === "CANCELED" ||
          status.id === "UNPROCESSED"
        ) {
          failedCounts += status.count;
          failedAmount += parseInt(status.amount);
        } else {
          pendingCounts += status.count;
          pendingAmount += parseInt(status.amount);
        }
      });

      const result1 = [
        { id: "SUCCESS", amount: successAmount, count: successCounts },
        { id: "FAILED", amount: failedAmount, count: failedCounts },
        { id: "PENDING", amount: pendingAmount, count: pendingCounts },
      ];

      const result = await applyReversedToSuccess(result1, secondsValue);

      if (graph === PIEGRAPH) {
        setTransactionStatuswithAmountPout(result);
      } else if (graph === BARGRAPH) {
        setTransactionStatuswithAmountPoutBar((prevState) => {
          const existingEntryIndex = prevState.findIndex(
            (item) => item.date === date
          );

          if (existingEntryIndex !== -1) {
            const updatedState = [...prevState];
            updatedState[existingEntryIndex] = { date, data: result };
            return updatedState;
          } else {
            return [...prevState, { date, data: result }];
          }
        });
      }
    } catch (error) {
      console.error("Error fetching PAY-OUT data:", error);
      // Handle error, show toast, etc.
    }
  };

  useEffect(() => {
    getStatusPin(today, PIEGRAPH);
    getStatusPout(today, PIEGRAPH);
  }, [mid]);

  useEffect(() => {
    getStatusPin(selectedDatePin, PIEGRAPH);
  }, [selectedDatePin]);

  useEffect(() => {
    getStatusPout(selectedDatePout, PIEGRAPH);
  }, [selectedDatePout]);

  const pieDataPayin = {
    labels: transactionStatuswithAmountPin.map((item) => item.id),
    datasets: [
      {
        data: transactionStatuswithAmountPin.map((item) => item.count), // Number of transactions
        backgroundColor: ["#61bd6d", "#d9534f", "#f0ad4e"],
        hoverBackgroundColor: ["#61bd6d", "#d9534f", "#f0ad4e"],
        amountData: transactionStatuswithAmountPin.map((item) => item.amount), // Corresponding amounts
      },
    ],
  };
  const pieDatapayout = {
    labels: [
      transactionStatuswithAmountPout[0].id,
      transactionStatuswithAmountPout[1].id,
      transactionStatuswithAmountPout[2].id,
    ],
    datasets: [
      {
        data: [
          transactionStatuswithAmountPout[0].count,
          transactionStatuswithAmountPout[1].count,
          transactionStatuswithAmountPout[2].count,
        ], // Number of transactions
        backgroundColor: ["#61bd6d", "#d9534f", "#f0ad4e"],
        hoverBackgroundColor: ["#61bd6d", "#d9534f", "#f0ad4e"],
        amountData: [
          transactionStatuswithAmountPout[0].amount,
          transactionStatuswithAmountPout[1].amount,
          transactionStatuswithAmountPout[2].amount,
        ], // Corresponding amounts
      },
    ],
  };

  const pieOptions = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const data = tooltipItem.dataset.data;
            const amountData = tooltipItem.dataset.amountData;
            const totalTransactions = data.reduce(
              (acc, value) => acc + value,
              0
            );
            const currentTransactions = data[tooltipItem.dataIndex];
            const currentAmount = amountData[tooltipItem.dataIndex];
            const percentage = (
              (currentTransactions / totalTransactions) *
              100
            ).toFixed(2);
            return `${
              tooltipItem.label
            }: ${currentTransactions} Txns, ₹ ${currentAmount.toLocaleString()}, (${percentage}%)`;
          },
        },
      },
    },
  };

  const barDataPin = {
    labels: transactionStatuswithAmountPinBar.map((item) => item.date),
    datasets: [
      {
        label: "Success",
        backgroundColor: "#61bd6d",
        data: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "SUCCESS").count
        ),
        amount: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "SUCCESS").amount
        ),
      },
      {
        label: "Pending",
        backgroundColor: "#f0ad4e",
        data: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "PENDING").count
        ),
        amount: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "PENDING").amount
        ),
      },
      {
        label: "Failed",
        backgroundColor: "#d9534f",
        data: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "FAILED").count
        ),
        amount: transactionStatuswithAmountPinBar.map(
          (item) => item.data.find((status) => status.id === "FAILED").amount
        ),
      },
    ],
  };

  const barDataPout = {
    labels: transactionStatuswithAmountPoutBar.map((item) => item.date),
    datasets: [
      {
        label: "Success",
        backgroundColor: "#61bd6d",
        data: transactionStatuswithAmountPoutBar.map(
          (item) => item.data.find((status) => status.id === "SUCCESS").count
        ),
      },
      {
        label: "Pending",
        backgroundColor: "#f0ad4e",
        data: transactionStatuswithAmountPoutBar.map(
          (item) => item.data.find((status) => status.id === "PENDING").count
        ),
      },
      {
        label: "Failed",
        backgroundColor: "#d9534f",
        data: transactionStatuswithAmountPoutBar.map(
          (item) => item.data.find((status) => status.id === "FAILED").count
        ),
      },
    ],
  };
  const options = {
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.dataset.label || "";
            const count = context.raw;
            const amount = transactionStatuswithAmountPoutBar[
              context.dataIndex
            ].data.find((status) => status.id === label.toUpperCase()).amount;
            const totalCount = context.dataset.data.reduce(
              (sum, val) => sum + val,
              0
            );
            const percentage = ((count / totalCount) * 100).toFixed(2);
            return `${label}: ${count} Txns, ${amount} amount, ${percentage}%`;
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
  };

  const handleDateChangePin = (e) => {
    setSelectedDatePin(e.target.value);
  };
  const handleDateChangePout = (e) => {
    setSelectedDatePout(e.target.value);
  };
  return (
    <MidSections
      {...{
        pieDataPayin,
        pieDatapayout,
        pieOptions,
        barDataPin,
        barDataPout,
        selectedDatePin,
        handleDateChangePin,
        selectedDatePout,
        handleDateChangePout,
        options,
        today,
        transactionStatuswithAmountPinBar,
        transactionStatuswithAmountPoutBar,
      }}
    />
  );
};

export default HomePage;
